import type { Kennzahl, GetValuesFn } from './types'

/**
 * Parst einen Comment-String in ein Array von Zahlenwerten.
 * Erwartet kommagetrennte Zahlen (z. B. "1.2,3.4,5.6").
 * Gibt ein leeres Array zurück, wenn keine validen Zahlen gefunden werden —
 * dann wird der `wert`-Einzelwert als Fallback verwendet.
 */
function getValuesFromComment(comment: string): number[] {
    return comment
        .split(',')
        .map((s) => parseFloat(s.trim()))
        .filter((n) => !isNaN(n))
}

/**
 * Baut ein BoxPlot-Dataset aus den Kommentar-Werten oder dem Einzel-Wert.
 *
 * Verwendung: Kennzahlen mit `types: ['BoxPlotChart', ...]`.
 */
export function buildBoxPlotChartData(kennzahl: Kennzahl, getValues: GetValuesFn, baseYears: string[]): any {
    const currentValues = getValues(kennzahl.kennzahlId)
    let isDataEmpty = true
    const data: number[][] = []

    baseYears.forEach((semester) => {
        const row = currentValues.sort((a, b) => (a.year < b.year ? 1 : -1)).find((v) => v.semester === semester)

        if (row?.comment) {
            const valuesFromComment = getValuesFromComment(row.comment)
            if (!valuesFromComment.length) {
                data.push([Number(row.wert)])
            } else {
                data.push(valuesFromComment)
            }
        } else {
            data.push([])
        }
    })

    data.forEach((item) => {
        if (item.length) isDataEmpty = false
    })

    if (isDataEmpty || !currentValues.length) return false

    return {
        labels: baseYears,
        datasets: [
            {
                label: 'IST-Wert',
                data,
                backgroundColor: '#004699',
                borderColor: '#000000',
                itemRadius: 0,
                itemStyle: 'point',
                borderWidth: 1
            }
        ]
    }
}
